import React, { useState } from "react";
// import classes from "../assets/styles/ForgotPassword.module.css";
import FormInput from "../components/Forms/FormInput";
import { loggedInUser } from "../utils/store";
import { useAtom } from "jotai";
import { Link } from "react-router-dom";
import { post } from "../server";
import { useNavigate } from "react-router-dom";
import ValidateSchema from "../helpers/ValidateSchema";
import showToast from "../helpers/showToast";
import Joi from "joi";
import _ from "lodash";
import Loader from "../components/Loader";
import { TiTick } from "react-icons/ti";
import logo from "../assets/images/signup_icons/logo-dark.svg";

import {
  FORGET_PASSWORD,
  CHECK_OTP,
  RESET_PASSWORD,
} from "../utils/constants/apiUrl";
import { Button } from "react-bootstrap";

const subTitle = [
  "Enter your email address and we'll send you a link to reset your password.",
  "We've sent you an email with verification code. Please enter code to continue.",
  "Enter your new password",
];

const buttonText = ["Send Reset Link", "Continue", "Submit"];

const step0Schema = Joi.object({
  email: Joi.string()
    .max(50)
    .email({ tlds: { allow: false } })
    .required()
    .messages({
      "string.empty": `Please enter email`,
      "string.email": `Please enter valid email address`,
      "string.max": `Email must be maximum 50 characters!`,
    }),
});

const step1Schema = Joi.object({
  email: Joi.string()
    .max(50)
    .email({ tlds: { allow: false } })
    .required()
    .messages({
      "string.empty": `Please enter email`,
      "string.email": `Please enter valid email address`,
      "string.max": `Email must be maximum 50 characters!`,
    }),
  otp_code: Joi.string().max(6).min(6).required().messages({
    "string.empty": `Please enter opt code`,
    "string.max": `OTP code must be minimum or maximum 6 digits!`,
    "string.min": `OTP code must be minimum or maximum 6 digits!`,
  }),
});

const step2Schema = Joi.object({
  email: Joi.string()
    .max(50)
    .email({ tlds: { allow: false } })
    .required()
    .messages({
      "string.empty": `Please enter email address`,
      "string.email": `Please enter valid email address`,
      "string.max": `Email must be maximum 50 characters!`,
    }),

  otp_code: Joi.string().max(6).min(6).required().messages({
    "string.empty": `Please enter opt code`,
    "string.max": `OTP code must be minimum or maximum 6 digits!`,
    "string.min": `OTP code must be minimum or maximum 6 digits!`,
  }),

  new_password: Joi.string().min(8).required().messages({
    "string.empty": `Please enter password`,
    "string.min": `Password must be minimum 8 characters!`,
  }),
  confirm_password: Joi.string()
    .required()
    .valid(Joi.ref("new_password"))
    .messages({
      "string.empty": `Please enter confirm password `,
      "any.only": `Confirm password must match new password`,
    }),
});

const ForgotPassword = () => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const [forgetPassword, setForgetPassword] = useState({
    email: "",
    otp_code: "",
    new_password: "",
    confirm_password: "",
  });

  const [stepValue, setStepValue] = useState(0);

  // const handleChange = (e) => {
  //   const name = e.target.name;
  //   const value = e.target.value;
  //   setForgetPassword({ ...forgetPassword, [name]: value });
  // };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    // Update the form state
    setForgetPassword({ ...forgetPassword, [name]: value });

    // Clear the error for the current field if it exists
    if (errors[name]) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const validateForm = (schema) => {
    let newErrors = ValidateSchema(forgetPassword, schema);
    setErrors(newErrors);
    if (Object.keys(newErrors).length) return false;
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (stepValue === 0) {
      if (!validateForm(step0Schema)) return;
    }
    if (stepValue === 1) {
      if (!validateForm(step1Schema)) return;
    }
    if (stepValue === 2) {
      if (!validateForm(step2Schema)) return;
    }
    setLoading(true);

    let payload = _.cloneDeep(forgetPassword);

    let step = stepValue;
    if (stepValue == 0) {
      let { status, message, data } = await post(
        FORGET_PASSWORD,
        {
          email: payload.email,
        },
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );

      if (status) {
        step = 1;
      } else {
        showToast(status, message);
      }
    } else if (stepValue == 1) {
      let { status, message, data } = await post(
        CHECK_OTP,
        {
          email: payload.email,
          code: payload.otp_code,
        },
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );

      if (status) {
        step = 2;
      } else {
        showToast(status, message);
      }
    } else if (stepValue == 2) {
      let { status, message, data } = await post(
        RESET_PASSWORD,
        {
          email: payload.email,
          code: payload.otp_code,
          password: payload.new_password,
          confirm_password: payload.confirm_password,
        },
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );

      if (status) {
        step = 3;
        showToast(status, "Your Password is updated Successfully");
        navigate("/login");
      }
      // showToast(status, message);
    }
    setStepValue(step);
    setLoading(false);
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <section className="auth-page">
          <div className="container-fluid h-100">
            <div className="row h-100 align-items-center">
              <div className="col-12 col-md-6 col-lg-6 d-flex justify-content-center align-items-center left-panel">
                <div className="left-panel-inner">
                  <img src={logo} alt="logo" className="logo mb-4" />
                  {/* <h1 className="heading">Hello, Welcome Back</h1> */}
                  <p className="subHeading">
                    Experience the future of networking with us, and together,
                    let’s “Connect. Share. Inspire.”
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-6 right-panel d-flex justify-content-center align-items-center">
                <div className="right-panel-inner">
                  <h1>Forgot Password</h1>
                  <p className="mb-4">{subTitle[stepValue]}</p>
                  <div>
                    {stepValue == 0 && (
                      <>
                        <FormInput
                          // label="Recovery Email"
                          placeholder="Email Address"
                          name="email"
                          type="text"
                          value={forgetPassword.email}
                          handleChange={handleChange}
                          error={errors?.email}
                          autofocus={true}
                        />
                      </>
                    )}

                    {stepValue == 1 && (
                      <>
                        <FormInput
                          // label="Enter Code"
                          placeholder="Otp Code"
                          name="otp_code"
                          type="number"
                          value={forgetPassword.otp_code}
                          handleChange={handleChange}
                          error={errors?.otp_code}
                          autofocus={true}
                        />
                      </>
                    )}

                    {stepValue == 2 && (
                      <>
                        <FormInput
                          // label="New Password"
                          placeholder="New Password"
                          name="new_password"
                          type="password"
                          value={forgetPassword.new_password}
                          handleChange={handleChange}
                          error={errors?.new_password}
                          autofocus={true}
                        />
                        <FormInput
                          // label="Confirm Password"
                          placeholder="Confirm Password"
                          name="confirm_password"
                          type="password"
                          value={forgetPassword.confirm_password}
                          handleChange={handleChange}
                          error={errors?.confirm_password}
                          // autofocus={true}
                        />
                      </>
                    )}

                    {stepValue == 3 ? (
                      <>
                        <div className=""></div>
                        <span className="dot">
                          <TiTick />
                        </span>
                        <div>
                          <p className="successFooter">
                            Your Password is updated
                            <br></br>
                            <span>Successfully</span>
                          </p>
                        </div>
                      </>
                    ) : (
                      <Button
                        variant="primary"
                        className="btn-block w-100"
                        onClick={handleSubmit}
                      >
                        {buttonText[stepValue]}
                      </Button>
                    )}

                    <div className="text-end mt-3 mb-4">
                      <Link to="/login">Back to Sign In</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default ForgotPassword;
